import { render } from "./giving-options.vue?vue&type=template&id=977e7dc2&scoped=true"
import script from "./giving-options.vue?vue&type=script&lang=js"
export * from "./giving-options.vue?vue&type=script&lang=js"

import "./giving-options.vue?vue&type=style&index=0&id=977e7dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977e7dc2"]])

export default __exports__